import { useRouteLocale } from "@/hooks/useRouteLocale";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTES } from "@/routes";
import { useAuth } from "@/hooks/useAuth";
import { useTranslation } from "@/hooks/useTranslation";

export default function LogoutPage() {
  const { logout } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = useRouteLocale();
  const currentLocale = locale || "ro";

  useEffect(() => {
    const run = async () => {
      try {
        await logout();
      } finally {
        navigate(PUBLIC_ROUTES.login(currentLocale));
      }
    };
    void run();
  }, [logout, navigate, currentLocale]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-3">
        <p className="text-lg font-medium text-foreground">{t("auth.loggingOut")}</p>
        <p className="text-sm text-muted-foreground">
          {t("auth.redirecting")}
        </p>
      </div>
    </div>
  );
}

